import { FileDown, Pencil, Trash2 } from "lucide-react";
import { api, formatApiError, formatDate } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { openBlob } from "@/lib/docOptions";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { toast } from "sonner";

export const DocRow = ({ kind, d, subtitle, onEdit, onChanged, children }) => {
  const { user } = useAuth();
  const del = async () => {
    if (!window.confirm("Kayıt silinsin mi?")) return;
    try { await api.delete(`/${kind}/${d.id}`); toast.success("Silindi"); onChanged(); } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
  };
  return (
    <Card data-testid={`${kind}-row-${d.id}`} className="p-4 space-y-2">
      <div className="flex flex-col md:flex-row md:items-center gap-3">
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2 flex-wrap">
            <span className="font-semibold text-slate-900">{d.title}</span>
            {d.auto && <Badge variant="outline" className="border-sky-400 text-sky-700" data-testid={`${kind}-auto-${d.id}`}>Portföyden otomatik</Badge>}
          </div>
          <div className="text-xs text-slate-500 mt-0.5">{subtitle} · {d.created_by_name} · {formatDate(d.created_at)}</div>
        </div>
        <div className="flex gap-2">
          <Button size="sm" data-testid={`${kind}-pdf-${d.id}`} className="bg-slate-900" onClick={() => openBlob(`/${kind}/${d.id}/pdf`)}><FileDown className="w-4 h-4 mr-1" />PDF</Button>
          <Button size="sm" variant="outline" data-testid={`${kind}-edit-${d.id}`} onClick={() => onEdit(d)}><Pencil className="w-4 h-4" /></Button>
          {(user.role === "BROKER" || d.created_by === user.id) && <Button size="sm" variant="ghost" data-testid={`${kind}-delete-${d.id}`} onClick={del}><Trash2 className="w-4 h-4 text-red-600" /></Button>}
        </div>
      </div>
      {children}
    </Card>
  );
};
